import React, {useState, useEffect} from 'react';
import api from '../services/api';
import '../styles/AcquisitionModal.css';

export default function AcquisitionModal({acquisition, onClose, onSave}) {
    const [form, setForm] = useState({
        companyName: '',
        contactPerson: '',
        contactEmail: '',
        contactPhone: '',
        projectTitle: '',
        projectDescription: '',
        classification: '',
        expectedBudget: '',
        status: '',
        offerFilePath: '',
        offerAmount: '',
        notes: '',
        offerDate: ''
    });

    useEffect(() => {
        if (acquisition) {
            setForm({
                ...acquisition,
                offerDate: acquisition.offerDate ? acquisition.offerDate.substring(0, 10) : ''
            });
        }
    }, [acquisition]);

    const handleChange = (e) => {
        const {name, value} = e.target;
        setForm(prev => ({...prev, [name]: value}));
    };

    const handleSubmit = () => {
        if (!form.companyName || !form.projectTitle || !form.contactPerson) {
            alert('Please fill in all required fields.');
            return;
        }

        if (acquisition) {
            // Update
            api.patch(`/projectacquisition/${acquisition.id}`, form)
                .then(onSave)
                .catch(err => alert('Update failed'));
        } else {
            // Add new project acquisition
            const json_post = {
                "CompanyName": form.companyName,
                "ContactPerson": form.contactPerson,
                "ContactEmail": form.contactEmail,
                "ContactPhone": form.contactPhone,
                "ProjectTitle": form.projectTitle,
                "ProjectDescription": form.projectDescription,
                "Classification": form.classification,
                "ExpectedBudget": parseInt(form.expectedBudget),
                "Status": form.status,
                "OfferFilePath": form.offerFilePath,
                "OfferAmount": parseInt(form.offerAmount),
                "OfferDate": form.offerDate || null,
                "Notes": form.notes || null,
            }
            console.log(json_post);
            console.log(JSON.stringify(json_post));

            api.post('/projectacquisition', json_post)
                .then(onSave)
                .catch(err => alert('Creation failed'));
        }
    };

    return (
        <div className="modal-overlay">
            <div className="modal">
                <h3>{acquisition ? 'Anfrage bearbeiten' : 'Neue Anfrage hinzufügen'}</h3>
                <div className="form">
                    <input name="companyName" placeholder="Firma" value={form.companyName} onChange={handleChange}
                           className="input"/>
                    <input name="contactPerson" placeholder="Ansprechpartner" value={form.contactPerson}
                           onChange={handleChange} className="input"/>
                    <input name="contactEmail" placeholder="Email" value={form.contactEmail} onChange={handleChange}
                           className="input"/>
                    <input name="contactPhone" placeholder="Telefonnummer" value={form.contactPhone}
                           onChange={handleChange} className="input"/>
                    <input name="projectTitle" placeholder="Projekt Titel" value={form.projectTitle}
                           onChange={handleChange} className="input"/>
                    <input name="projectDescription" placeholder="Projektbeschreibung" value={form.projectDescription}
                           onChange={handleChange} className="input"/>
                    <input name="classification" placeholder="Klassifikation (e.g. PLC)" value={form.classification}
                           onChange={handleChange} className="input"/>
                    <input type="number" name="expectedBudget" placeholder="Erwartetes Budget (€)"
                           value={form.expectedBudget} onChange={handleChange} className="input"/>
                    <select name="status" value={form.status} onChange={handleChange} className="input">
                        <option value="">Status wählen</option>
                        <option value="New">Neu</option>
                        <option value="InProgress">In Bearbeitung</option>
                        <option value="OfferCreated">Angebot erstellt</option>
                        <option value="Won">Gewonnen</option>
                        <option value="Lost">Verloren</option>
                    </select>
                    <input name="notes" placeholder="Notizen" value={form.notes} onChange={handleChange}
                           className="input"/>

                    <input name="offerFilePath" placeholder="File Path" value={form.offerFilePath}
                           onChange={handleChange} className="input"/>


                    <input type="number" name="offerAmount" placeholder="Angebotsbetrag (€)" value={form.offerAmount}
                           onChange={handleChange} className="input"/>
                    <input type="date" name="offerDate" value={form.offerDate} onChange={handleChange}
                           className="input"/>

                    <div className="form-buttons">
                        <button className="button" onClick={handleSubmit}>💾 Speichern</button>
                        <button className="button button-danger" onClick={onClose}>❌ Abbrechen</button>
                    </div>
                </div>
            </div>
        </div>
    );
}
